import { ContainerWYSIWYG } from './ContainerWYSIWYG';

export default ContainerWYSIWYG;